/* RESPONSIBLE TEAM: team-omni */
import Service from '@ember/service';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type Session from 'embercom/services/session';

type TelegramIntegration = {
  id: string;
};

export default class TelegramIntegrationService extends Service {
  @service declare session: Session;

  @tracked existingIntegrationsIds: string[] | null = null;

  async loadIntegration(): Promise<void> {
    if (!this.session.workspace.isFeatureEnabled('telegram-channel')) {
      return;
    }

    try {
      let response = await fetch(
        `/ember/telegram/integrations?app_id=${this.session.workspace.id}`,
      );

      if (response.ok) {
        let integrations = (await response.json()) as TelegramIntegration[];
        this.existingIntegrationsIds = integrations.map((integration) => integration.id);
        return;
      }

      console.error('Error loading Telegram integration:', response.statusText);
    } catch (error) {
      console.error('Error loading Telegram integration:', error);
    }

    this.existingIntegrationsIds = null;
  }

  get hasIntegrations(): boolean {
    return (this.existingIntegrationsIds?.length ?? 0) > 0;
  }
}

declare module '@ember/service' {
  interface Registry {
    'telegram-integration-service': TelegramIntegrationService;
  }
}
